import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
const initialState: any = [];
const { persistAtom } = recoilPersist();
export const chatState = atom({
  key: "chatState",
  default: initialState,
});
